import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getUnreadedNotifications = async (controller) => {
  try {
    const url = config.apiserver + "/notification/getunreadednotification";

    let res = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const updateNotificationReaded = async (newData, controller) => {
  try {
    let url = config.apiserver + "/notification/updateNotificationReaded";
    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getNotifications = async (controller) => {
  try {
    let url = config.apiserver + "/notification/getnotification";
    let response = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
